module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "rightPanel",
    staticClass: "rightPanel-container",
    style: ({
      bottom: (_vm.bottom + "px")
    })
  }, [_c('button', {
    staticClass: "handler-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onClick.apply(null, arguments)
      }
    }
  }, [_vm._v("分享")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6529b708!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideFloat.vue
// module id = 582
// module chunks = 1